import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { siteUrl } from '../data/metadata';


const RoomSchema = ({ name, description, slug, roomsSlug, image, locale }) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HotelRoom',
    name,
    description: description
      ? description
        .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
        .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
        .replace(/[#*_\n]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .substring(0, 300)
      : name,
    url: `${siteUrl}/${locale}/${roomsSlug}/${slug}/`,
    image: image || undefined,
    containedInPlace: {
      '@type': 'Hotel',
      '@id': 'https://www.michelbergerhotel.com/#hotel',
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

RoomSchema.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  slug: PropTypes.string.isRequired,
  roomsSlug: PropTypes.string.isRequired,
  image: PropTypes.string,
  locale: PropTypes.string.isRequired,
};

export default RoomSchema;
